import { actionTypes as types } from './constants';

export const fetchRecipes = (filters, advancePage) => ({
    type: types.FETCH_RECIPES_START,
    filters,
    advancePage
});

export const handleRecipeFilter = (filterTitle, name, checked) => {
    return {
        type: types.RECIPES_FILTER_CHANGE,
        payload: { filterTitle, name, checked }
    }
};

export const fetchHeaderRecipe = () => {
    return {
        type: types.FETCH_HEADER_RECIPE_START
    }
};

export const fetchDetailedRecipe = (slug) => {
    return {
        type: types.FETCH_DETAILED_RECIPE_START,
        slug
    }
}

export const updateRecipeSearchFilters = (filters) => {
    return {
        type: types.UPDATE_RECIPE_FILTERS,
        payload: { filters }
    }
}

export const resetRecipeSearchFilters = () => {
    return {
        type: types.RESET_RECIPE_FILTERS
    }
}
